import fetchApiWithAuth from './fetch';

export type BrandProps = {
  name: string;
};

export const getAll = async () => {
  const result = await fetchApiWithAuth('/api/goods/brands', {
    method: 'GET',
  });
  const data = (await result.json()) as BrandProps[];
  return data;
};

export const create = async (props: BrandProps) => {
  const result = await fetchApiWithAuth('/api/goods/brands', {
    method: 'POST',
    body: JSON.stringify(props),
  });
  const data = (await result.json()) as BrandProps;
  return data;
};
